import * as React from 'react';

import { starRatingOptions } from './constants';
import { EStarRating, NonEmptyArray } from '../../../../../JsonQuery';
import { Select, Option } from '../../Select';

interface IStarRatingProps {
  label: string | null;
  value: NonEmptyArray<EStarRating> | null;
  popupPostfix?: React.ReactNode;
  onChange(value: EStarRating[] | null): void;
}

export const StarRating: React.FC<IStarRatingProps> = ({ label, value, popupPostfix, onChange }) => {
  return (
    <Select
      multiple
      withoutArrow
      label={label || undefined}
      placeholder="Количество звёзд"
      value={value}
      onChange={(_, value: EStarRating[] | null) => onChange(value)}
      popupPostfix={popupPostfix}
    >
      {starRatingOptions.map(({ label, value }) => (
        <Option key={label} value={value}>
          {label}
        </Option>
      ))}
    </Select>
  );
};
